import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PlanningLeftoverTimelineItemCtrl implements IController {

  leftover: any;
  selectedLeftOverIds: any;
  stopsWarnings: any;
  onDragStart: Function;

  /* @ngInject */
  constructor(public $element) {
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.stopsWarnings) {
      if (this.stopsWarnings) {
        _.forEach(this.leftover.stops, (s) => {
          s.warnings = this.stopsWarnings[s.id] || [];
        });
      }
    }
  }

  $postLink() {
    this.$element.on('dragstart', (event) => {
      this.onDragStart({leftover: this.leftover, event: event});
    });
  }

  isLeftOverSelected(job) {
    return _.includes(this.selectedLeftOverIds, job.id);
  }
}

angular
  .module('bringoz.admin.planning')
  .component(
    'planningLeftoverTimelineItem', {
      bindings: {
        leftover: '<',
        selectedLeftOverIds: '<',
        stopsWarnings: '<',
        onDragStart: '&'
      },
      template: require('./planning-leftover-timeline-item.html').default,
      controller: PlanningLeftoverTimelineItemCtrl
    }
  );
